import React from "react";
import { lightTheme as T } from "../../Constants/Colors";
import { fontFamily, fontSize, fontWeight, spacing, subHeading2, body } from "../../Constants/Fonts";

// Right-hand "Foresee" evaluation panel. Self-styled from theme tokens so it
// renders correctly regardless of the surrounding layout.
function NovaPanel({ novaError, checkingId, novaData }) {
    const sectionTitle = (text) => (
        <h5 style={{ ...body({ color: T.primary }), fontWeight: fontWeight.semibold, margin: `${spacing['2xl']}px 0 ${spacing.md}px` }}>
            {text}
        </h5>
    );

    return (
        <div
            style={{
                background: T.surface,
                border: `1px solid ${T.border}`,
                borderRadius: T.radiusLg,
                boxShadow: T.shadowSm,
                padding: spacing['3xl'],
                height: "calc(100vh - 260px)",
                overflowY: "auto",
                fontFamily,
            }}
        >
            <h4 style={{ ...subHeading2({ color: T.primary }), textAlign: "center", marginBottom: spacing['3xl'] }}>
                Foresee
            </h4>

            {novaError && (
                <div
                    style={{
                        color: T.danger,
                        background: T.dangerSoft,
                        border: `1px solid ${T.danger}`,
                        borderRadius: T.radiusSm,
                        padding: "8px 12px",
                        marginBottom: spacing['2xl'],
                        ...body(),
                    }}
                >
                    {novaError}
                </div>
            )}

            <div>
                {checkingId && (
                    <>
                        <div className="shimmer-line mb-3" />
                        <div className="shimmer-line mb-3" />
                        <div className="shimmer-line mb-3" />
                    </>
                )}

                {novaData && (
                    <div style={{ ...body({ color: T.textSecondary }), lineHeight: 1.55 }}>
                        {sectionTitle("Decision")}
                        <p style={{ margin: 0, color: T.textPrimary }}>{novaData?.evaluation?.decision}</p>

                        {sectionTitle("Summary")}
                        <p style={{ margin: 0 }}>{novaData?.evaluation?.summary}</p>

                        {novaData?.evaluation?.violations?.length > 0 && (
                            <>
                                {sectionTitle("Violations")}
                                <ul style={{ margin: 0, paddingLeft: 18 }}>
                                    {novaData.evaluation.violations.map((v, i) => (
                                        <li key={i}>{v}</li>
                                    ))}
                                </ul>
                            </>
                        )}

                        {novaData?.evaluation?.missing_evidence?.length > 0 && (
                            <>
                                {sectionTitle("Missing Evidence")}
                                <ul style={{ margin: 0, paddingLeft: 18 }}>
                                    {novaData.evaluation.missing_evidence.map((m, i) => (
                                        <li key={i}>{m}</li>
                                    ))}
                                </ul>
                            </>
                        )}
                    </div>
                )}

                {!checkingId && !novaData && !novaError && (
                    <p style={{ ...body({ color: T.textMuted }), textAlign: "center", marginTop: spacing['4xl'] }}>
                        Run <span style={{ color: T.primary, fontWeight: fontWeight.semibold }}>Check with Foresee</span> on a question to see the AI evaluation here.
                    </p>
                )}
            </div>
        </div>
    );
}

export default NovaPanel;
